import { __assign, __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart, ReferenceLine, ReferenceArea } from 'recharts';
import { linesToData } from './lines-to-data';
export var LineChartKey = 'line-chart';
var LineChart = /** @class */ (function (_super) {
    __extends(LineChart, _super);
    function LineChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeDataIndex: undefined,
            tooltipXCoordinate: 0,
            rechartsData: linesToData(_this.props.lines)
        };
        _this.ref = React.createRef();
        _this.lastAddedLineIds = _this.props.lines.map(function (l) { return l.id; });
        _this.isChangingLineCount = false;
        _this.colors = {
            white: '#fff',
            strokeGrey: '#dfe5eb',
            tickGrey: '#9aa9be',
            darkBlue: '#577083'
        };
        _this.handleMouseMove = function (data) {
            if (!data.isTooltipActive) {
                _this.setState({ activeDataIndex: undefined });
            }
            else if (data.activeTooltipIndex >= 0) {
                _this.setState({ activeDataIndex: data.activeTooltipIndex, tooltipXCoordinate: data.activeCoordinate.x });
            }
        };
        _this.handleMouseLeave = function () { return _this.setState({ activeDataIndex: undefined }); };
        _this.renderChartLines = function () {
            return _this.props.lines.map(function (line) { return (React.createElement(Area, { type: 'monotone', key: line.id, dataKey: line.id, stroke: line.color, strokeWidth: '2', fillOpacity: '0.1', fill: line.color, activeDot: { r: 5, stroke: line.color, fill: _this.colors.white, strokeWidth: 2 }, isAnimationActive: (_this.lastAddedLineIds.indexOf(line.id) > -1) || !_this.isChangingLineCount })); });
        };
        _this.renderBottomTooltip = function (data) {
            var _a = _this, state = _a.state, props = _a.props;
            if (state.activeDataIndex === undefined) {
                return null;
            }
            var ttBottomStyle = {
                transform: "translateX(" + state.tooltipXCoordinate + "px) translateX(-50%) translateY(-56px)",
            };
            return props.bottomTooltipLabel && data[state.activeDataIndex] ? (React.createElement("div", { className: 'line-chart-vertical-tooltip bottom', style: ttBottomStyle }, props.bottomTooltipLabel(data[state.activeDataIndex].x))) : null;
        };
        _this.renderTopTooltip = function (data) {
            var _a = _this, state = _a.state, props = _a.props;
            var activeDataIndex = state.activeDataIndex;
            if (activeDataIndex === undefined) {
                return null;
            }
            var ttStyle = {
                transform: "translateX(" + state.tooltipXCoordinate + "px) translateX(-50%)",
            };
            var activeX = activeDataIndex >= 0 && data[activeDataIndex] ? data[activeDataIndex].x : null;
            var shouldShowIndicator = _this.props.lines.length > 1;
            var topTooltipItems = activeX && props.topTooltipLabel ? _this.props.lines.map(function (line) {
                var maybeValue = line.values.find(function (value) { return value.x === activeX; });
                var valueForLine = maybeValue ? maybeValue.y : undefined;
                return (React.createElement("div", { key: line.id, className: 'top-tooltip-item' },
                    shouldShowIndicator ? React.createElement("div", { className: 'line-indicator', style: { background: line.color } }) : null,
                    props.topTooltipLabel(activeX, valueForLine)));
            }) : null;
            return (React.createElement("div", { className: 'line-chart-vertical-tooltip top', style: ttStyle }, topTooltipItems));
        };
        _this.renderThresholdLable = function () {
            var props = _this.props;
            return (React.createElement("text", { className: 'threshold-lable', style: { fill: props.threshold ? props.threshold.color : 'white' } },
                React.createElement("tspan", { className: 'lable-span', x: '24', y: 100 }, _this.props.threshold ? _this.props.threshold.from + "%" : '')));
        };
        _this.renderThreshold = function () {
            var props = _this.props;
            if (props.threshold) {
                return ([
                    (React.createElement("defs", null,
                        React.createElement("linearGradient", { id: 'line-gradient-area', x2: '0', y2: '1' },
                            React.createElement("stop", { offset: '0%', stopOpacity: '0', stopColor: props.threshold.color }),
                            React.createElement("stop", { offset: '100%', stopOpacity: '0.2', stopColor: props.threshold.color })))), (React.createElement(ReferenceLine, { y: props.threshold.from, stroke: props.threshold.color, label: _this.renderThresholdLable, strokeDasharray: '3 3', isFront: true })), (React.createElement(ReferenceArea, { y1: props.threshold.from, stroke: 'none', strokeDasharray: '3 3' }))
                ]);
            }
            else {
                return [];
            }
        };
        return _this;
    }
    LineChart.prototype.componentWillReceiveProps = function (nextProps) {
        var newLines = nextProps.lines;
        var currLineIds = this.props.lines.map(function (l) { return l.id; });
        this.lastAddedLineIds = newLines.filter(function (l) { return currLineIds.indexOf(l.id) === -1; }).map(function (l) { return l.id; });
        this.isChangingLineCount = nextProps.lines.length !== this.props.lines.length;
        var rechartsData = linesToData(nextProps.lines);
        this.setState({ rechartsData: rechartsData });
    };
    LineChart.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.ref.current &&
                _this.ref.current.querySelectorAll('.recharts-reference-line-line')[0] && _this.props.threshold) {
                var getY = _this.ref.current.querySelectorAll('.recharts-reference-line-line')[0].getAttribute('y1');
                var yVal = getY ? Number(getY) + 4 : 0;
                _this.ref.current.querySelectorAll('.lable-span')[0].setAttribute('y', "" + yVal);
            }
        }, 200);
    };
    LineChart.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps !== this.props) {
            if (this.ref.current &&
                this.ref.current.querySelectorAll('.recharts-reference-line-line')[0] && this.props.threshold) {
                var getY = this.ref.current.querySelectorAll('.recharts-reference-line-line')[0].getAttribute('y1');
                var yVal = getY ? Number(getY) + 4 : 0;
                this.ref.current.querySelectorAll('.lable-span')[0].setAttribute('y', "" + yVal);
            }
        }
    };
    LineChart.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var rechartsData = state.rechartsData;
        var classNames = namespacedClassnames(LineChartKey, props.className, { 'is-multi-line': props.lines.length > 1 });
        var areaChartMargin = { top: 10, right: 10, bottom: 10, left: 10 };
        var xTickLine = { stroke: this.colors.strokeGrey, strokeDasharray: '2 2' };
        var areaChartProps = {
            data: rechartsData,
            onMouseMove: this.handleMouseMove,
            onMouseLeave: this.handleMouseLeave,
            margin: areaChartMargin
        };
        return (React.createElement("div", { className: classNames, ref: this.ref },
            this.renderTopTooltip(rechartsData),
            React.createElement(ResponsiveContainer, { width: props.width || '99%', height: props.height || 400 },
                React.createElement(AreaChart, __assign({}, areaChartProps),
                    React.createElement(CartesianGrid, { stroke: this.colors.strokeGrey, strokeDasharray: '2 2' }),
                    React.createElement(XAxis, { tickMargin: 10, dataKey: 'x', axisLine: { stroke: this.colors.strokeGrey }, tickLine: xTickLine, tickSize: 10, tick: { fill: this.colors.tickGrey, fontSize: 12 }, tickFormatter: props.xAxisTickLabel }),
                    React.createElement(YAxis, { tickMargin: 20, tickCount: 10, axisLine: { stroke: '#dfe5eb' }, tickLine: false, tick: { fill: this.colors.tickGrey, fontSize: 12 }, tickFormatter: props.yAxisTickLabel }),
                    React.createElement(Tooltip, { content: React.createElement("span", null), cursor: { stroke: this.colors.darkBlue, strokeWidth: 2 }, isAnimationActive: false }),
                    this.renderChartLines(),
                    this.renderThreshold())),
            this.renderBottomTooltip(rechartsData)));
    };
    return LineChart;
}(React.PureComponent));
export { LineChart };
//# sourceMappingURL=index.js.map